import { formatUnixDate } from "core/model/utils/dates";
import {
  BarthelAssessment,
  EarlyRehabAssessment,
  SingerAssessment,
} from "core/types";
import { Link } from "react-router-dom";
import { Locale } from "translations";
import Translations from "translations/types";

export function StaticIndependenceScaleResult({
  goTo,
  linkLabel,
  locale,
  testId,
  title,
  translations,
  value,
}: {
  goTo?: string;
  linkLabel?: string;
  locale: Locale;
  testId:
    | "singer-assessment-result"
    | "early-rehab-assessment-result"
    | "barthel-assessment-result";
  title: string;
  translations: Translations;
  value?: SingerAssessment | BarthelAssessment | EarlyRehabAssessment;
}) {
  if (typeof value?.score !== "number" || !value.date) return null;

  return (
    <div className="flex flex-col px-4 py-1" data-testid={testId}>
      <h3 className="py-0.5 text-sm font-bold">{title}:</h3>
      <dl className="flex flex-col space-y-0.5 text-sm">
        <div className="flex space-x-1" data-testid={`${testId}-score`}>
          <dt>
            {
              translations.patient.medicalDiagnosis.singerPatientProfile
                .scoreTitle
            }
          </dt>
          <dl>{value.score}</dl>
        </div>
        <div className="flex space-x-1" data-testid={`${testId}-date`}>
          <dt>
            {
              translations.patient.medicalDiagnosis.singerPatientProfile
                .dateTitle
            }
          </dt>
          <dl>{formatUnixDate(value.date, locale)}</dl>
        </div>
      </dl>
      {value.form && goTo && linkLabel && (
        <Link
          className="cursor-pointer text-sm font-bold text-primary hover:underline"
          to={goTo}
        >
          {linkLabel}
        </Link>
      )}
    </div>
  );
}
